import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import ExplorePage from './components/ExplorePage';
import LocationPage from './components/LocationPage';
import LandingPage from './components/LandingPage';
import Footer from './components/Footer';
import './App.css';

// TOGGLE THIS FLAG TO SWITCH BETWEEN LANDING PAGE AND FULL APP
const SHOW_LANDING_PAGE = false;

// Component that determines layout based on current route
function AppContent() {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';
  const isHomePage = location.pathname === '/';
  const [activeTab, setActiveTab] = useState('map');
  
  if (isAboutPage) {
    // About page (landing page) - full height layout
    return (
      <div className="App landing-mode">
        <Header />
        <LandingPage />
        <Footer />
      </div>
    );
  }
  
  if (isHomePage) {
    // Home page - no background pattern
    return (
      <div className="App">
        <Header activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="app-content home-page">
          <Routes>
            <Route 
              path="/" 
              element={<HomePage />} 
            />
          </Routes>
        </div>
        <Footer />
      </div>
    );
  }
  
  // Regular app layout for map and location pages
  return (
    <div className="App">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="app-content">
        <Routes>
          <Route 
            path="/explore" 
            element={<ExplorePage activeTab={activeTab} setActiveTab={setActiveTab} />} 
          />
          <Route 
            path="/location/:locationId" 
            element={<LocationPage />} 
          />
        </Routes>
      </div>
      {location.pathname !== '/explore' && <Footer />}
    </div>
  );
}

function App() {
  // If landing page mode, show only the landing page
  if (SHOW_LANDING_PAGE) {
    return (
      <div className="App landing-mode">
        <LandingPage />
      </div>
    );
  }

  // Full app functionality with dynamic layout
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<AppContent />} />
        <Route path="/about" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App;
